import { useEffect } from "react";

interface BlogModalProps {
  blog: any;
  onClose: () => void;
}

const BlogModal: React.FC<BlogModalProps> = ({ blog, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  if (!blog) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-2 sm:px-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white w-full max-w-5xl h-[95vh] rounded-3xl shadow-2xl overflow-hidden flex flex-col">
        
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-30 w-9 h-9 flex items-center justify-center rounded-full bg-black/70 text-white hover:bg-black transition"
        >
          ✕
        </button>

        {/* Scrollable content wrapper */}
        <div className="overflow-y-auto flex-1">

          {/* Image */}
          <div className="w-full bg-gray-100 flex items-center justify-center">
            <img
              src={blog.image}
              alt={blog.title}
              className="max-h-[280px] w-auto object-contain"
            />
          </div>

          {/* Header */}
          <div className="px-6 sm:px-10 py-6 border-b">
            <span className="inline-block mb-3 px-4 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary">
              {blog.category}
            </span>

            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-3">
              {blog.title}
            </h2>

            <div className="flex flex-wrap gap-3 text-sm text-gray-400">
              <span>{blog.author}</span>
              <span>•</span>
              <span>{blog.date}</span>
              <span>•</span>
              <span>{blog.readTime}</span>
            </div>
          </div>

          {/* Content */}
          <div className="px-6 sm:px-10 py-8 pb-16">
            <p className="text-gray-600 leading-relaxed whitespace-pre-line text-base sm:text-lg">
              {blog.content}
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default BlogModal;
